import { CreditCardOutlined, LockOutlined } from "@ant-design/icons";
import { DateDisplay } from "@easybiz/component";
import { usePOSIsDayClosed } from "@easybiz/hook";
import {
  useLicenseCloseOfDay,
  useLicenseExpired,
  useLicenseExpiringTimestamp
} from "@easybiz/component-shared";
import { Alert } from "antd";
import { getAuth, signOut } from "firebase/auth";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Dialog from "../Dialog";

export default function () {
  const invalid = useLicenseExpired();
  const expiringTimestamp = useLicenseExpiringTimestamp();
  const intl = useIntl();
  const isDayClosed = usePOSIsDayClosed();
  const closedDate = useLicenseCloseOfDay();

  if (invalid) {
    return (
      <Dialog
        open
        title={<FormattedMessage tagName="span" defaultMessage="Your license has expired!" />}
        okText={intl.formatMessage({ defaultMessage: "Sign out" })}
        onOk={() => signOut(getAuth())}
        disabled
      >
        <Alert
          type="info"
          message={
            <FormattedMessage
              defaultMessage="Please check your subscription from <b>Admin console</b>"
              values={{
                b: (t) => <b>{t}</b>,
              }}
            />
          }
          description={
            <FormattedMessage
              tagName="span"
              defaultMessage="You can still access your shop data using your admin account from the admin console."
            />
          }
        />
      </Dialog>
    );
  } else if (expiringTimestamp) {
    return (
      <div className="padding-half">
        <Alert
          type="error"
          showIcon
          icon={<CreditCardOutlined />}
          message={
            <FormattedMessage
              defaultMessage="Subscription due, your license will be <b>suspend {date}</b>"
              values={{ date: <DateDisplay timestamp={expiringTimestamp} hideTime />, b: (t) => <b>{t}</b> }}
            />
          }
        />
      </div>
    );
  } else if (isDayClosed) {
    return (
      <div className="padding-half">
        <Alert
          type="info"
          showIcon
          icon={<LockOutlined />}
          message={
            <FormattedMessage
              defaultMessage={
                "Close of day submitted for {date}, you can not do sales related operations until tomorrow"
              }
              values={{
                date: (
                  <b>
                    <DateDisplay date={closedDate} />
                  </b>
                ),
              }}
            />
          }
        />
      </div>
    );
  } else {
    return null;
  }
}
